// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__rxy0-","loader":"loader_loader__5x2cA","background":"loader_background__Ql0UH"};